export const THEMES = {
  LIGHT: "LIGHT",
  DARK: "DARK",
};

export const STRINGS = {
  EMPTY: "",
  LOCAL_STORAGE_TOKEN: "token",
  LOCAL_STORAGE_USER: "user",
  EMAIL_ADDRESS: "Email Address",
  FIRST_NAME: "First Name",
  LAST_NAME: "Last Name",
  PASSWORD: "Password",
  SIGNUP: "Sign Up",
  LOGIN: "Login",
  IDP_LOGIN: "IDP Login",
  LOGOUT: "Logout",
  INBOX: "Inbox",
  USERNAME: "Username",
  ORGANIZATION_NAME: "Organization Name",
  SIGNIN_GITHUB: "Signin with github",
  SIGNIN_VMONE: 'Signin with Provider',
  PASSCODE: "Passcode",
  LOCAL_STORAGE_REDIRECT_TO: "redirectTo",
};

export const ERROR_CODES = {
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  SERVER_TIMEOUT: "ECONNABORTED",
};

export const ERRORS = {
  FIRST_NAME_EMPTY: "First Name cannot be empty",
  LAST_NAME_EMPTY: "Last Name cannot be empty",
  EMAIL_EMPTY: "Email cannot be empty",
  INVALID_EMAIL: "Enter valid email",
  PASSWORD_EMPTY: "Password cannot be empty",
  PASSWORD_LENGTH_SHORT: "Password needs to be at least 8 characters long",
  PASSWORDS_NOT_SAME: "Passwords don't match",
  SERVER_TIMEOUT: "Server Timeout",
  PASSCODE_EMPTY: "Passcode cannot be empty",
  PASSCODE_INVALID: "Enter Valid Passcode",
  PERMISSION_DENIED: "You don't have permission to take that action",
};

export const API_SLUGS = {
  LOGIN: "/user/login",
  LOGIN_METHOD: "user/loginType",
  IDP_LOGIN: "/user/login/sso",
  SIGNIN_GITHUB: "/user/auth/github",
  SIGNIN_VMONE: "/user/auth/workspace",
  FT_AUTH_HANDLER: "/user/auth/federatedtoken/{token}",
  SIGNUP: "/user/signup",
  MESSAGES: "/message",
  MESSAGES_SUMMARY: "/message/summary",
  MESSAGE: "/message/{uuid}",
  MARK_MESSAGE: "/message/{uuid}",
  ALERTS: "/alert",
  ALERT: "/alert/{uuid}",
  MARK_ALERT: "/alert/{uuid}",
  USER_PROFILE_SETTINGS: "/user",
  CHANGE_PASSWORD: "/user/password",
  CURRENT_USER_DETAILS: "/user/current",
  SLACK_CONNECT: "/user/slack",
  SLACK_DISCONNECT: "/user/slackdisconnect",
  ADD_ANALYZER: "/analyzer",
  ADD_BATCH_ANALYZER: "/analyzer/batch-upload",
  ANALYZERS: "/analyzer?{contextLevel}={uuid}",
  ANALYZER: "/analyzer/{uuid}",
  ANALYZER_SUMMARY: "/summary/dashboard-overview?{contextLevel}={uuid}",
  DELETE_ANALYZERS: "/analyzer/batch-delete",
  EXECUTE_ANALYZERS: "/analyzer/execute",
  ADD_ANALYZER_VERSION: "/analyzer/{uuid}/version",
  ANALYZER_VERSIONS: "/analyzer/{uuid}/version",
  DELETE_ANALYZER_VERSIONS: "/analyzer/{uuid}/version/batch-delete",
  IDP_MAPPINGS: "/role/idp-roles",
  SAVE_IDP_MAPPINGS: "/role/idp-roles",
  ROLES: "/role",
  ROLE: "/role/{uuid}",
  ADD_ROLE: "/role",
  EDIT_ROLE: "/role/{uuid}",
  DELETE_ROLES: "/role/batch-delete",
  PERMISSIONS: "/permission",
  SUMMARY: "/summary",
  DASHBOARDS: "/dashboard",
  PROJECTS: "/projects",
  PROJECTS_BY_GROUP: "/projects?groupId={groupId}",
  GET_PROJECT: "/projects/{uuid}",
  ADD_PROJECT: "/projects",
  UPDATE_PROJECT: "/projects/{id}",
  SERVICES: "/project/{uuid}/services",
  GET_SERVICE: "/service/{uuid}",
  ADD_SERVICE: "/service",
  APIS: "/apis?projectId={projectId}",
  GET_API: "/apis/{uuid}",
  GET_ASSET: "/assets/{uuid}",
  UPDATE_API: "/apis/{id}",
  ADD_API: "/apis",
  ADD_ASSET: "/assets",
  ASSETS: "/assets?projectId={projectId}",
  GRAPH: "/apis/{assetId}/revisions/{revId}/ddg",
  UPDATE_REVISION: "/apis/{uuid}/revisions/{revId}",
  LIST_REVISIONS: "/apis/{uuid}/revisions",
  DEFINITION: "/apis/{assetId}/revisions/{revId}/definition",
  BUBBLE_CHART: "/results/chart-data?apiUUID={uuid}{resultCount}",
  ADD_ENVIRONMENT: "/projects/{projectId}/environments",
  GET_ENVIRONMENT: "/environments/{id}",
  UPDATE_ENVIRONMENT: "/projects/{projectId}/environments/{id}",
  ENVIRONMENTS: "/environments",
  INSIGHTS_ENVIRONMENTS:
    "/insights/environments?projectIds={projectIds}",
  ADD_PLATFORM_KEY: "/user/accesstokens",
  REVOKE_PLATFORM_KEY: "/user/accesstokens/{id}",
  ADD_JOB_SPEC: "/jobs",
  ADD_ORGANIZATION: "/organization",
  ORGANIZATIONS: "/organization",
  SET_CONTEXT: "/user/context",
  GET_CONTEXT: "/user/context",
  GET_USER_INVITES: "/user/invites",
  ACTION_USER_INVITES: "/user/invites/{id}",
  SEND_INVITES: "/invites",
  GET_INVITES: "/invites",
  ACTION_INVITES: "/invites/{id}",
  POST_TIMELINE: "/issues/{id}/timeline",
  ALLOWED_DOMAINS: "/jobs/allowedDomains",
  GET_ORGANIZATION_MEMBERS: "/organization/members",
  FAULT_ANALYZERS: "/faultanalyzers",
  JIRA_PROJECTS: "/jira/projects",
  POST_JIRA_ISSUE: "/jira/issue",
  MFA_SETTINGS: "/user/mfa/settings",
  MFA_QRCODE: "/user/mfa/qrcode",
  MFA_VERIFY: "/user/mfa/verifytotp",
  RUN_CONFIGURATIONS: "/run/configurations",
  GET_PLANS: "/plans",
  GET_OPERATIONS: "/apis/{assetId}/operations",
  GET_OPERATIONS_BY_RESULT: "/results/{resultId}/operations",
  GET_OPERATIONS_PERFORMANCE_BY_RESULT: "/results/{resultId}/operations/temp",
  GET_OPERATIONS_BY_REVISION: "/apis/{assetId}/revisions/{revisionId}/operations",
  GET_USER_OPERATIONS_SETTINGS: "/apis/{assetId}/operations/resourceprofiles",
  GET_PERMISSION_BLACKLIST: "/plans/permissions?type='restricted'",
  GET_ACTIVE_PLAN: "/activeplan",
  GET_GROUPS: "/group",
  GET_GROUP: "/group/{id}",
  ADD_GROUP: "/group",
  UPDATE_GROUP: "/group/{id}",
  ADD_MEMBER: "/group/{groupId}/member",
  UPDATE_MEMBER: "/group/{groupId}/member/{id}",
  ORG_MEMBERS: "/organization/members",
  UPDATE_ORG_MEMBER: "/organization/members/{id}",
  VIEW_PROJECTS: "/insights/projectsview",
  RUNS_REPORT: "/reporting/runs",
  ASSETS_REPORT: "/reporting/assets",
  USERS_REPORT: "/reporting/users",
  INVITES_REPORT: "/reporting/invites",
  GET_VARIABLES: "/generatorsets",
  POST_VARIABLES: "/generatorsets",
  GET_VARIABLES_DATA: "/generatorsets/{id}",
  PATCH_VARIABLES_DATA: "/generatorsets/{id}",
  TOOL_POLICIES: "/tool/policies",
  TOOL_POLICY: "/tool/policies/{id}",
  ISSUES: "/issues",
  ISSUES_REPORT: "/reporting/issues",
  CLOUD_INTEGRATION: "/cloudintegration",
  LINK_TO_JIRA: "/projects/{projectId}/jira",
  POST_ISSUE_TO_JIRA: "/jira/issues",
  GITLAB_PROJECTS: "/cloudintegration/projects?type=gitlab",
  GITLAB_BRANCHES: "/cloudintegration/projects/branches?type=gitlab",
  GITHUB_PROJECTS: "/cloudintegration/projects?type=github",
  GITHUB_BRANCHES: "/cloudintegration/projects/branches?type=github",
  CLOUD_INTEGRATION_PROJECTS: "/cloudintegration/projects",
  CLOUD_INTEGRATION_BRANCHES: "/cloudintegration/projects/branches",
  GITLAB_RUN: "/cloudintegration/projects/run",
  PATTERNS: "/patterns",
  PATTERN: "/patterns/{id}"
};

export const ROUTES = {
  JOIN: "/join",
  LOGIN: "/login",
  SIGNUP: "/sign-up",
  INBOX: "/inbox",
  TEAM: "/team",
  ALERTS: "/alerts",
  DASHBOARD: "/",
  SETTINGS: "/settings",
  USER_PROFILE_SETTINGS: "/settings/user-profile",
  IDP_MAPPING_SETTINGS: "/idp-mappings",
  CHANGE_PASSWORD: "/settings/change-password",
  IDP_REDIRECT_AUTH_HANDLER: "/__/auth/mercury-saml2",
  COLLECTIONS: "/analyzers/v/:context?/:uuid?",
  ADD_COLLECTION: "/analyzers/add",
  BATCH_ADD_COLLECTION: "/analyzers/add-multiple",
  COLLECTION_VERSIONS: "/analyzers/:uuid/versions",
  ADD_COLLECTION_VERSION: "/analyzers/:uuid/versions/add",
  ROLES: "/roles",
  ADD_ROLE: "/roles/add",
  EDIT_ROLE: "/roles/:uuid",
  ADD_PROJECT: "/project/add",
  ADD_SERVICE: "/service/add",
  ADD_API: "/api/add",

  ADD_REPOSITORY: "/repository/add",
  UPDATE_PROJECT: "/project/:uuid",
  UPDATE_SERVICE: "/service/:uuid",
  UPDATE_API: "/api/:uuid",
  GRAPH: "/revision/:uuid/graph",

  PROJECTS: "/projects",
  ENVIRONMENTS: "/environments",
  ADD_ENVIRONMENT: "/environment/add",
  UPDATE_ENVIRONMENT: "/environment/:uuid",
  ADD_ORGANIZATION: "/organization/add",
  PLATFORM_KEYS: "/platform-keys",
  ADD_PLATFORM_KEY: "/platform-key/add",
  INCIDENTS: "/issues",
  FINDINGS: "/findings",
  RESULTS: "/runs",
  LIST_JOBS: "/jobs/:jobId?",
  ADD_CONFIGS: "/addConfigs/:source?/:id?",
  EDIT_CONFIG: "/editConfig/:source?/:id?",
  LIST_SPECS: "/configurations",
  AUTOMATIONS: "/automations",
  RECOMMENDATIONS: "/embeddings",
  DOWNLOADS: "/downloads/:downloadId?",
  HAR_CONVERTER: "/har-converter",
  OPENAPI_MERGER: "/openapi-merger",
  POSTMAN_CONVERTER: "/postman-converter",
  GENERATORS: "/generators",
  API_DETAILS: "/api/:assetId/details",
  QUICK_START: "/quick-start",
  PLANS: "/plans",
  PLAN_SUCCESS: "/orders/:id/success",
  PLAN_FAILURE: "/orders/:id/failure",
  PROJECT: "/projects/:projectId",
  GROUPS: "/groups",
  VIEW_PROJECTS: "/viewProjects",
  UNKNOWN: "*",
  REPORTS: "/reports",
  GENERATOR_SETS: "/generator-sets",
  POLICIES: "/policies",
  POLICY: "/policy/:policyId",
  CLOUD_CONFIGURATION: "/cloud-configuration"
};
export const SEVERITY_OPTIONS = [
  { key: "critical", label: "Critical" },
  { key: "high", label: "High" },
  { key: "medium", label: "Medium" },
  { key: "low", label: "Low" },
  { key: "information", label: "Information" },
];
export const FINDING_TYPE_OPTIONS = [
  { key: "functional", label: "Functional" },
  { key: "security", label: "Security" },
];

export const NEW_OPTIONS = [
  { key: "true", label: "New" },

];

export const STATUS_OPTIONS = [
  { key: "open", label: "Open" },
  { key: "closed", label: "Closed" },
  
];

export const BOOL_OPTIONS = [
  { key: false, label: "No" },
  { key: true, label: "Yes" },
  
];

export const ANALYSIS_SCOPE_OPTIONS = [
  {
    key: true, label: "Unauthenticated and Authenticated",
  },
  { 
    key: false, label: "Unauthenticated Only"
  }
]

export const RISK_COUNT_MAP = {
    critical: 0,
    high: 0,
    medium: 0,
    low: 0,
    information: 0
}

export const HELPER_TEXTS = {
  add_project: {
    project: "The name of your Project e.g. Bookstore",
    group: "The name for your Group e.g. Bookstore Sales",
  },
  add_api: {
    project: "The name of your Project e.g. Bookstore",
    api: "The name for your API e.g. Bookstore API",
    type: "The type of your API specification",
  },
  add_repository: {
    project: "The name of your Project e.g. Bookstore",
    repository: "The name for your Repository e.g. BookstoreRepo",

  },
  add_platform_key: {
    platform_key:
      "You will need a Platform Key to connect to the Aptori platform. Please pick a name for your Platform Key",
    expiry: "The duration for the validity of the Platform Key",
  },
  add_environment: {
    environment: "The name for your Environment e.g. BookstoreCI",
  },
  add_group: {
    group: "The name for your Group e.g. Bookstore Sales",
  },
  add_job_configuration: {
    name: "The name for this configuration e.g. Bookstore",
    api: "The API to analyze.",
    environment: "The Environment in which you will execute the analysis.",
    target_url: "A valid URL, e.g. http://fawlty.xyz/ ",
    definition:
      "The location of your API Specification, e.g. http://fawlty.xyz/specification, or path to local file",
    revision: "Version of API specification",
    analyzers: "Select the Analyzers to include in the analysis.",
    trace_header:
      "A header to be included in each http request e.g. Sift-Request",
    included_operations:
      "The operations that you want to limit the analysis to.",
    excluded_operations:
      "The operations that you want to exclude from the analysis.",
    default_generators:
      "Generator sets to use.",
    safe_mode:
      "Safe mode excludes operations that modify state in target",
    exhaustive_mode:
      "Exhaustive mode attempts attacks in all fields of operations",
  },
  authorization: {
    title: "Authorization tokens to use in requests sent to a target API.",
    name: "User name for reference",
    user_name_literal: "Literal username (will be stored with configuration).",
    user_password_literal:
      "Literal password (will be stored with configuration).",
    user_name_template:
      "Name of environment variable containing username, e.g. USERNAME1",
    user_password_template:
      "Name of environment variable containing password, e.g. PASSWORD1",
    header_name: "Header name, e.g. authorization",
    header_value_literal:
      "Header value, e.g. bearer abcdef (will be stored with configuration).",
    header_value_template:
      "Name of environment variable containing header value, e.g. TOKEN1",
    command:
      "Command to execute to generate an authorization token.",
    http_command:
      "Command to execute to generate HTTP headers.",
    timeout:
      "Interval in seconds at which the command will be executed."
  },
  generators: {
    switch:
      "Input value generators used to produce values for input variables of an operation.",
  },
};

export const ALLOWED_PATHNAMES = [ROUTES.SETTINGS, ROUTES.EDIT_CONFIG];

export const GROUP_ROLES = [
  // {
  //   key: "administrator",
  //   name: "Administrator",
  //   description: "Administrator",
  // },
  {
    key: "owner",
    name: "Owner",
    description: "Owner",
  },
  {
    key: "maintainer",
    name: "Maintainer",
    description: "Maintainer",
  },
  {
    key: "developer",
    name: "Developer",
    description: "Developer",
  },
  {
    key: "guest",
    name: "Guest",
    description: "Guest",
  },
];

export const TOOL_TYPES: any = [
  {
    key: "api",
    label: "API"
  }, {
    key: "secret",
    label: "Secret"
  },
  {
    key: "dependency",
    label: "Dependency"
  },
  {
    key: "sast",
    label: "SAST"
  },
  {
    key: "container",
    label: "Container"
  },
  {
    key: "iac",
    label: "IAC"
  },
  {
    key: "k8s",
    label: "K8S"
  },{
    key: "aws",
    label: "AWS"
  },
  {
    key: "smart",
    label: "SMART"
  }
]
export const FACTS: any = [{
  type: "issue",
  label: "Issue",
  facts: [{
    key: "isNew",
    label: "New",
    type: "default",
    options: [{

      key: "true",
      label: "True"
    },
    {

      key: "false",
      label: "False"
    }]
  },
  {
    key: "findingType",
    label: "Type",
    type: "default",
    options: TOOL_TYPES
  },
  {
    key: "severity",
    label: "Severity",
    type: "default",
    options: [{

      key: "critical",
      label: "Critical"
    },{

      key: "high",
      label: "High"
    },
    {
      key: "medium",
      label: "Medium"
    },
    {
      key: "low",
      label: "Low"
    },
    {
      key: "information",
      label: "Information"
    }
  ]
    ,
  },
  {
    key: "risk",
    label: "Risk",
    type: "default",
    options: [{
      key: "critical",
      label: "Critical"
    },
    {
      key: "high",
      label: "High"
    },
    {
      key: "medium",
      label: "Medium"
    },
    {
      key: "low",
      label: "Low"
    },
    {
      key: "information",
      label: "Information"
    }]
    ,
  }

  ]
}]

export const SQL_INJECTION_PATTERNS = [
  /['";]/,               
  /(--|\b(OR|AND|DROP|SELECT|INSERT|DELETE|UPDATE|ALTER|EXEC|UNION|CREATE|TRUNCATE|JOIN)\b)/i, 
]

export enum LoginType {
  sso = "sso"
}

export enum FileType{
  octetStream = "application/octet-stream"
}

export const VARIABLE_TYPES = [
  {
    key: "StringConstant",
    name: "String"
  },
  {
    key: "Regex",
    name: "Regex"
  },
  {
    key: "IntConstant",
    name: "Number"
  },
  {
    key: "json",
    name: "JSON"
  }
];

export const TOOLS = [
  {
    key: "sift",
    name:"Sift"
  },
  {
    key: 'semgrep',
    name: 'Semgrep'
  },
  {
    key: 'trivy',
    name: 'Trivy'
  },
  {
    key: 'gitleaks',
    name: 'Gitleaks'
  },
  {
    key: 'osv',
    name: 'OSV'
  }
]

export const SEVERITY = [
  {
    key: "low",
    name: "Low"
  },
  {
    key: "medium",
    name: "Medium"
  },
  {
    key: "high",
    name: "High"
  },
  {
    key: "critical",
    name: "Critical"
  }
]

export const ISSUE_STATE_OPTIONS = [
  {
    key: "unassigned",
    label: "Unassigned"
  },
  {
    key: "assigned",
    label: "Assigned"
  },
  {
    key: "risk_accepted",
    label: "Accept Risk"
  },
  {
    key: "false_positive",
    label: "False Positive"
  },
  {
    key: "fixed_confirmed",
    label: "Fixed Confirmed"
  },
  {
    key: "fixed",
    label: "Fixed"
  },
  {
    key: "regression",
    label: "Regression"
  },
  {
    key: "fix_not_available",
    label: "Fix Not Available"
  },
];

export const FEATURES = {
  ASSET_API_OPENAPI: "asset:api:openapi",
  ASSET_API_GRAPHQL: "asset:api:graphql",
  JOBS: "jobs",
  GENERATOR_SETS: "generatorSets",
  AUTOMATIONS: "automations",
  REPORTS: "reports",
  RUN_TRIVY_LICENSE: "run:trivy:license",
  RUN_TRIVY_DEPENDENCY: "run:trivy:dependency",
  RUN_SEMGREP_SAST: "run:semgrep:sast",
  RUN_SIFT_API: "run:sift:api",
  ASSET_REPOSITORY: "asset:repository",
  AI_TRIAGE: "ai:triage",
  GITLAB_INTEGRATION: "aptori:cloudintegration:gitlab"
}

export const GITLAB_PROJECTS_INTEGRATION = [
  {
    key: "pipeline",
    name: "Pipeline"
  },
  {
    key: "cloud",
    name: "Cloud"
  }
];

export enum PatternType {
  GLOBAL = 'organization',
  GROUP = 'group'
}

export const FEATURE_ROUTE_MAP: Record<string, string> = {
  "/reports": FEATURES.REPORTS,
  "/automations": FEATURES.AUTOMATIONS,
  "/generator-sets": FEATURES.GENERATOR_SETS,
};

export const SCAN_TOOLS = [
    { group: "SAST",            type: "sast",       tool: "semgrep",  dockerRunner: true,  cloudRunner: true },
    { group: "SAST",            type: "sast",       tool: "opengrep", dockerRunner: true,  cloudRunner: true },
    { group: "SAST",            type: "sast",       tool: "Smart",    dockerRunner: false, cloudRunner: true },
    { group: "Dependency, SCA", type: "dependency", tool: "trivy",    dockerRunner: true,  cloudRunner: true },
    { group: "Secrets",         type: "secret",     tool: "gitleaks", dockerRunner: true,  cloudRunner: true },
    { group: "Licenses",        type: "license",    tool: "trivy",    dockerRunner: true,  cloudRunner: true },
    { group: "IaC",             type: "iac",        tool: "trivy",    dockerRunner: true,  cloudRunner: true }
  ];
